
function create_tooltip(){
	
//For Special Notes Tooltip	
	$("img.special-notes").each(
	function(){
		$(this).qtip({
		content: $("#tooltip_"+ $(this).attr('id')).html(),
		show: { when: 'mouseover', delay:10 },
		hide: { when: 'mouseout', fixed: true },
		style: { 
			name: 'dark' ,// Inherit from preset style
			background: '#1d4f8d',
			textAlign: 'center',
			padding:'3px 5px',
			border: { color: '#a6a8ab',  width: 2 },
			tip: { 
			corner: 'bottomMiddle', 
			size: {
            	x: 10, 
            	y : 8 
         	}
		} 
   },
		position: {
			corner: {
				target: 'topMiddle',
				tooltip: 'bottomMiddle'
      		}
   		}

	});
});
	
	$(".poi img").each(
	function(){
		// var str =$(this).attr('alt');
		// str= str.replace(/[\(\)]/g,'');		
		$(this).qtip({
		content: $(this).attr('alt'),
		show: { when: 'mouseover', delay:10 },
		hide: { when: 'mouseout', fixed: true },
		style: { 
			name: 'dark' ,// Inherit from preset style
			background: '#f05a28',
			textAlign: 'center',
			padding:'3px 5px',
			border: { color: '#a6a8ab',  width: 2 },
			tip: { 
			corner: 'bottomMiddle', 
			size: {
            	x: 10, 
            	y : 8 
         	}
		} 
   },
		position: {
			corner: {
				target: 'topMiddle',
				tooltip: 'bottomMiddle'
      		}
   		}

	});
});

	
	$('.moderate').qtip({
		content: 'Moderate<br /> <a href="javascript:void(0)" onclick="openBox(\'/assetroot/html/global/excursion/icon_definitions.html\')">Click for details</a>',
		show: { when: 'mouseover', delay:10 },
		hide: { when: 'mouseout', fixed: true },
		style: { 
			name: 'dark' ,// Inherit from preset style
			background: '#ffb800',
			textAlign: 'center',
			padding:'2px 5px',
			lineHeight:'12px',
			border: { color: '#a6a8ab',  width: 1, radius: 2  },
			tip: { 
			corner: 'bottomMiddle', // We declare our corner within the object using the corner sub-option
			size: {
            	x: 10, // Be careful that the x and y values refer to coordinates on screen, not height or width.
            	y : 8 // Depending on which corner your tooltip is at, x and y could mean either height or width!
         	}
		} 
   },
		position: {
			corner: {
				target: 'topMiddle',
				tooltip: 'bottomMiddle'
      		}
   		}

	});
	
	$('.strenuous').qtip({
		content: 'Strenuous<br /> <a href="javascript:void(0)" onclick="openBox(\'/assetroot/html/global/excursion/icon_definitions.html\')">Click for details</a>',
		show: { when: 'mouseover', delay:10 },
		hide: { when: 'mouseout', fixed: true },
		style: { 
			name: 'dark' ,// Inherit from preset style
			background: '#ca0000',
			textAlign: 'center',
			padding:'2px 5px',
			lineHeight:'12px',
			border: { color: '#a6a8ab',  width: 1, radius: 2  },
			tip: { 
			corner: 'bottomMiddle', 
			size: {
            	x: 10, 
            	y : 8 
         	}
		} 
   },
		position: {
			corner: {
				target: 'topMiddle',
				tooltip: 'bottomMiddle'
      		}
   		}

	});
	
		$('.wheelchair').qtip({
		content: 'Wheelchair Accessible<br /> <a href="javascript:void(0)" onclick="openBox(\'/assetroot/html/global/excursion/icon_definitions.html\')">Click for details</a>',
		show: { when: 'mouseover', delay:10 },
		hide: { when: 'mouseout', fixed: true },
		style: { 
			name: 'dark' ,// Inherit from preset style
			background: '#0071bc',
			textAlign: 'center',
			padding:'3px 5px',
			lineHeight:'12px',
			border: { color: '#a6a8ab',  width: 1, radius: 2  },
			tip: { 
			corner: 'bottomMiddle', 
			size: {
            	x: 10, 
            	y : 8 
         	}
		} 
   },
		position: {
			corner: {
				target: 'topMiddle',
				tooltip: 'bottomMiddle'
      		}
   		}
	});
	
		
		$('.easy').qtip({
		content: 'Easy<br /> <a href="javascript:void(0)" onclick="openBox(\'/assetroot/html/global/excursion/icon_definitions.html\')">Click for details</a>',
		show: { when: 'mouseover', delay:10 },
		hide: { when: 'mouseout', fixed: true },
		style: { 
			name: 'dark' ,// Inherit from preset style
			background: '#7dbe28',
			textAlign: 'center',
			padding:'2px 5px',
			lineHeight:'12px',
			border: { color: '#a6a8ab',  width: 1, radius: 2  },
			tip: { 
			corner: 'bottomMiddle', 
			size: {
            	x: 10, 
            	y : 8 
         	}
		} 
   },
		position: {
			corner: {
				target: 'topMiddle',
				tooltip: 'bottomMiddle'
      		}
   		}
	});

	
		$('.snack').qtip({
		content: 'Snack Included',
		show: { when: 'mouseover', delay:10 },
		hide: { when: 'mouseout', fixed: true },
		style: { 
			name: 'dark' ,// Inherit from preset style
			background: '#93278f',
			textAlign: 'center',
			padding:'3px 5px',
			lineHeight:'12px',
			border: { color: '#a6a8ab',  width: 1, radius: 2  },
			tip: { 
			corner: 'bottomMiddle', 
			size: {
            	x: 10, 
            	y : 8 
         	}
		} 
   },
		position: {
			corner: {
				target: 'topMiddle',
				tooltip: 'bottomMiddle'
      		}
   		}
	});
	
		$('.shopping').qtip({
		content: 'Shopping Opportunity',
		show: { when: 'mouseover', delay:10 },
		hide: { when: 'mouseout', fixed: true },
		style: { 
			name: 'dark' ,// Inherit from preset style
			background: '#00a99d',
			textAlign: 'center',
			padding:'3px 5px',
			lineHeight:'12px',
			border: { color: '#a6a8ab',  width: 1, radius: 2  },
			tip: { 
			corner: 'bottomMiddle', 
			size: {
            	x: 10,
            	y : 8 
         	}
		} 
   },
		position: {
			corner: {
				target: 'topMiddle',
				tooltip: 'bottomMiddle'
      		}
   		}
	});
	
	$('.meal').qtip({
		content: 'Meal Included',
		show: { when: 'mouseover', delay:10 },
		hide: { when: 'mouseout', fixed: true },
		style: { 
			name: 'dark' ,// Inherit from preset style
			background: '#585aa8',
			textAlign: 'center',
			padding:'3px 5px',
			lineHeight:'12px',
			border: { color: '#a6a8ab',  width: 1, radius: 2  },
			tip: { 
			corner: 'bottomMiddle', 
			size: {
            	x: 10, 
            	y : 8 
         	}
		} 
   },
		position: {
			corner: {
				target: 'topMiddle',
				tooltip: 'bottomMiddle'
      		}
   		}
	});
	
	$('.share').qtip({
		content: {
			text: '<div class="tooltip-content"><p>You may continue selecting additional excursions, or<br /> <a href="javascript:sharedShxView(\'' + $('#portName').val() + '\');">click to share what you&rsquo;ve selected so far</a>.</p>',
			title: {
				text: 'Share Excursions'
			}
		},
		show: { when: 'mouseover', delay:10 },
		hide: { when: 'mouseout', fixed: true },
		style: { 
			background: '#0054A0',
			textAlign: 'left',
			padding:'8px',
			width: '380px',
			fontSize: '14px',
			lineHeight:'18px',
			border: { 
				color: '#0054A0',  
				width: 1, 
				radius: 0 
			},
			tip: { 
				corner: 'rightMiddle', // We declare our corner within the object using the corner sub-option
				size: {
					x: 19, // Be careful that the x and y values refer to coordinates on screen, not height or width.
					y : 22 // Depending on which corner your tooltip is at, x and y could mean either height or width!
				}
			},
			classes: {
				tooltip: 'qtip-share-shadow',
				title: 'qtip-share-title',
				content: 'qtip-share-content'
			}
	},
		position: {
			corner: {
				target: 'leftMiddle',
				tooltip: 'rightMiddle'
			}
		},
		api: {
			beforeShow: function() {
				var boxesChecked = $('.share > input:checked').length;
				if ($('.share > input:checked').length > 0) {
					return true;
				} else {
					return false;
				}
			}
		}
	});

}

$(document).ready(function() {
	create_tooltip();	
});
